import React, { Component, Fragment } from 'react';
import { convertToRupiah } from '../../../config/utils';
import { getUser } from '../../../services/api-services/krs-api';
import { getRiwayatPembayaran } from '../../../services/api-services/pembayaran';

class Riwayat extends Component {
  state = {
    history: [],
    user: [],
    optSemester: [],
    paidBills: '',
    unpaidBills: '',
    selectedSemester: false
  }

  componentDidMount() {
    this.getAllData();
  }

  getAllData = async () => {
    const nim = localStorage.getItem('nim')

    const allPromise = Promise.all([
      getUser(nim),
      getRiwayatPembayaran(nim)
    ])

    const promises = await allPromise;

    this.setState({
      user: promises[0].data,
      optSemester: promises[1].data.data.map((val) => ({ semester: val.semester })),
      history: promises[1].data.data,
      paidBills: promises[1].data.bayar_allsemester,
      unpaidBills: promises[1].data.tagihan_allsemester
    })
  }

  handleSemester = (e) => {
    this.setState({
      selectedSemester: e.target.value
    })
  }

  render() {
    const { user, optSemester, history, selectedSemester } = this.state

    return (
      <Fragment>
        <div className="smooth mb-2">
          <div className="col-md-12 mb-3">
            <div className="row">
              <div className="col-12 col-xl-8 mb-xl-0">
                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                  Keuangan&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Riwayat
                </p>
              </div>
            </div>
          </div>
          <div className="card card-custom">
            <div className="card-body">
              <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                Riwayat
              </p>
              <div className="table-responsive pl-2 pr-2">
                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>NIM</td>
                      <td> : </td>
                      <td>{user.nim}</td>

                      <td>Angkatan</td>
                      <td> : </td>
                      <td>{user.angkatan}</td>
                    </tr>
                    <tr>
                      <td>Nama</td>
                      <td> : </td>
                      <td>{user.nama}</td>

                      <td>Program Studi</td>
                      <td> : </td>
                      <td>{user.jurusan} </td>
                    </tr>
                    <tr>
                      <td>Tahun Akademik</td>
                      <td> : </td>
                      <td>{user.ta}</td>

                      <td>Semester</td>
                      <td> : </td>
                      <td>
                        <select onChange={this.handleSemester} className="form-control custom-width">
                          <option value="" hidden>- Pilih Semester -</option>
                          {
                            optSemester.map((v, index) => {
                              return (
                                <option key={index} value={v.semester}>{v.semester}</option>
                              )
                            })
                          }
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br /><br />
              <div className="table-responsive">
                <span><i className="ti-receipt menu-icon" /> &nbsp; Riwayat Pembayaran</span><br /><br />
                <table width="100%" align="center" className="display expandable-table table-bordered table-radius table-striped"
                >
                  <thead>
                    <tr align="center">
                      <th>Inv</th>
                      <th>Rincian Biaya</th>
                      <th>Tanggal</th>
                      <th>Nominal</th>
                      <th>Metode Bayar</th>
                      <th>Status</th>
                      <th>Petugas FO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      selectedSemester ?
                        history.length !== 0 &&
                        history.find((val) => val.semester === selectedSemester).history.map((btk, index) => (
                          <tr height={10} key={index}>
                            <td>{btk.inv}</td>
                            <td>{btk.namarincian}</td>
                            <td>{btk.tglbayar}</td>
                            <td>{convertToRupiah(btk.bayar)}</td>
                            <td>{btk.carabayar}</td>
                            <td>{btk.status}</td>
                            <td>{btk.admin}</td>
                          </tr>
                        )) : <tr><td colSpan={7} className='text-center'>Tidak Ada Data</td></tr>
                    }
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Riwayat
